export default function StandardsSection() {
  const standards = [
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20clean%20architecture%20visualization%2C%20ordered%20geometric%20blocks%20in%20warm%20coral%20and%20teal%20tones%2C%20structured%20layered%20design%2C%20dark%20minimal%20background%2C%20no%20text%20no%20people%20no%20devices%2C%20modern%20engineering%20aesthetic%2C%20precise%20geometric%20composition&width=300&height=200&seq=standard-01&orientation=landscape',
      alt: 'Abstract clean architecture representation',
      title: 'Clean Architecture',
      label: 'Foundation',
      standard: 'SOLID Principles',
      hasBadge: true,
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20code%20quality%20visualization%2C%20geometric%20precision%20patterns%2C%20warm%20amber%20and%20coral%20gradient%20tones%2C%20dark%20background%2C%20clean%20lines%2C%20no%20text%20no%20people%20no%20devices%2C%20minimal%20modern%20aesthetic&width=300&height=200&seq=standard-02&orientation=landscape',
      alt: 'Abstract code review and quality representation',
      title: 'Code Review',
      label: 'Practice',
      standard: 'Peer-Driven Quality',
      hasBadge: false,
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20testing%20automation%20visualization%2C%20repeating%20geometric%20patterns%20in%20teal%20and%20coral%20tones%2C%20representing%20continuous%20verification%2C%20dark%20minimal%20background%2C%20no%20text%20no%20people%20no%20devices%2C%20clean%20structured%20composition&width=300&height=200&seq=standard-03&orientation=landscape',
      alt: 'Abstract testing and automation representation',
      title: 'Automated Testing',
      label: 'Process',
      standard: 'Comprehensive Coverage',
      hasBadge: false,
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Abstract%20continuous%20delivery%20visualization%2C%20flowing%20geometric%20shapes%20in%20warm%20coral%20gradients%2C%20representing%20smooth%20deployment%20pipelines%2C%20dark%20minimal%20background%2C%20no%20text%20no%20people%20no%20devices%2C%20elegant%20abstract%20composition&width=300&height=200&seq=standard-04&orientation=landscape',
      alt: 'Abstract continuous integration representation',
      title: 'Continuous Delivery',
      label: 'Pipeline',
      standard: 'Streamlined Deployment',
      hasBadge: false,
    },
  ];

  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-950 leading-[1.2] tracking-tight">
            Technical Standards
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-5">
          {standards.map((std, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 border border-secondary-200/60">
              {std.hasBadge && (
                <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-4">
                  {std.label}
                </span>
              )}
              {!std.hasBadge && <div className="mb-4" />}
              <div className="relative rounded-md overflow-hidden w-full mb-5" style={{ aspectRatio: '3/2' }}>
                <img
                  src={std.image}
                  alt={std.alt}
                  title={std.alt}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 text-center">
                {std.title}
              </h3>
              <p className="text-sm text-foreground-500 text-center mt-1">
                {std.standard}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}